import {
  GET_ALL_USERS,
  GET_ALL_ADMIN_USERS_RESPONSE_SUCCESS,
  CREATE_USER,
  DELETE_USER,
  UPDATE_USER,
} from "./actionTypes"

export const getAllUsers = userType => {
  return {
    type: GET_ALL_USERS,
    payload: userType,
  }
}

export const deleteUser = (type, id) => {
  return {
    type: DELETE_USER,
    payload: {
      type: type,
      id: id,
    },
  }
}
export const getAllAdminUsersResponseSuccess = payload => ({
  type: GET_ALL_ADMIN_USERS_RESPONSE_SUCCESS,
  payload: payload,
})
// ------------------------------------- CREATE USER--------------------------------------------------------

export const createUser = (payload, toggle) => {
  return {
    type: CREATE_USER,
    payload: payload,
    toggle,
  }
}

export const updateUser = (payload, toggle) => ({
  type: UPDATE_USER,
  payload: payload,
  toggle,
})
